import React from 'react';
import { Route, Routes } from 'react-router-dom';

import useActiveAlienationSolution from '../useActiveAlienationSolution';

import Import from './Import';

const RoutesDomaine: React.FC = () => {
  const activeSolution = useActiveAlienationSolution();

  return (
    <Routes>
      {(!activeSolution || activeSolution?.contournementImportEnabled) && (
        <Route path="import" element={<Import />} />
      )}
    </Routes>
  );
};

export default RoutesDomaine;
